import { useAuth } from '../../contexts/AuthContext';
import styles from './WelcomeScreen.module.css';

export function WelcomeScreen() {
  const { wllUser } = useAuth();
  const greeting = wllUser ? `Hello, ${wllUser.firstName}` : 'Welcome';

  return (
    <div className={styles.welcome}>
      <div className={styles.icon} aria-hidden="true">
        <svg width="48" height="48" viewBox="0 0 32 32" fill="none">
          <rect width="32" height="32" rx="8" fill="#00AEBD" />
          <path
            d="M8 10h3l3 8 3-8h2l3 8 3-8h3l-4.5 12h-2.5l-2.5-7-2.5 7h-2.5L8 10z"
            fill="white"
          />
        </svg>
      </div>
      <h1 className={styles.heading}>{greeting}</h1>
      <p className={styles.subtitle}>
        I'm the Well Living Lab AI assistant. Ask me questions about indoor
        environments, health, and wellness research.
      </p>

      <div className={styles.suggestions}>
        <SuggestionChip text="What is the Well Living Lab?" />
        <SuggestionChip text="How does indoor air quality affect productivity?" />
        <SuggestionChip text="Summarize the latest wellness research findings" />
      </div>
    </div>
  );
}

function SuggestionChip({ text }: { text: string }) {
  return (
    <button className={styles.chip} type="button" aria-label={`Ask: ${text}`}>
      {text}
    </button>
  );
}
